/**
 * View component for /answers/new
 *
 * Creates a new answer from a copy of the defaultItem in the answer reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as answerActions from '../answerActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import answer components
import AnswerForm from '../components/AnswerForm.js.jsx';
import AnswerLayout from '../components/AnswerLayout.js.jsx';

class CreateAnswer extends Base {
  constructor(props) {
    super(props);
    this.state = {
      answer: _.cloneDeep(this.props.defaultAnswer)
      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newAnswerState = _.update( this.state.answer, e.target.name, function() {
      return e.target.value;
    });
    this.setState({answer :newAnswerState});
  }


  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(answerActions.sendCreateAnswer(this.state.answer)).then((action) => {
      if(action.success) {
        dispatch(answerActions.invalidateList());
        history.push(`/answers/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { answer } = this.state;
    const isEmpty = (answer.name === null || answer.name === undefined);
    return (
      <AnswerLayout>
        <div className="flex">
          <section className="section">
            {isEmpty ?
              <h2> Loading...</h2>
              :
              <AnswerForm
                answer={answer}
                cancelLink="/answers"
                formTitle="Create Answer"
                formType="create"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
                />
            }
          </section>
        </div>
      </AnswerLayout>
    )
  }
}

CreateAnswer.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultAnswer: store.answer.defaultItem
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(CreateAnswer)
);



// WEBPACK FOOTER //
// modules/answer/views/CreateAnswer.js.jsx